import { render, staticRenderFns } from "./FinancialSurveyChip.vue?vue&type=template&id=236a4132"
import script from "./FinancialSurveyChip.vue?vue&type=script&lang=js"
export * from "./FinancialSurveyChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports